"use strict";
export const migration23 = (state) => {
  if (!state?.favorites) {
    return state ? { ...state, _persist: { ...state._persist, version: 23 } } : void 0;
  }
  return {
    ...state,
    _persist: {
      ...state._persist,
      version: 23
    },
    // 清除旧的 favorite tokens，防止错误的 currencyId 映射
    favorites: {
      ...state.favorites,
      tokens: []
      // 清空所有收藏代币，用户需要重新收藏
    }
  };
};
